import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import CustomDate from '../CustomDate';
import messages from './messages';
import { styles } from './styles';

interface IExpirationDateProps {
  expirationDate: string;
  isRecurringPayment?: boolean;
  licencesPool?: number;
  multiplier: number;
  requirePaymentCount?: number;
}

export function ExpirationDate ({ expirationDate = "", isRecurringPayment, licencesPool, multiplier = 1, requirePaymentCount }: IExpirationDateProps) {
  return (licencesPool !== undefined && requirePaymentCount !== undefined
    && !isRecurringPayment && licencesPool < requirePaymentCount * multiplier)
    ? (
      <Typography sx={styles.text} variant="body2">
        <FormattedMessage
          values={{
            date: <CustomDate dateValue={expirationDate} />,
            text: (chunks) => (
              <Box component="span" sx={styles.textColor}>
                {chunks}
              </Box>
            ),
          }}
          {...messages.creditPoolCardExpiration}
        />
      </Typography>
    )
    : null;
}
